export class Coordinate {
    constructor(public latitude: number, public longitude: number) {
    }
}
